import React from 'react';
import PropTypes from 'prop-types';
import AnimatedNumber from "animated-number-react";
import {ProgressBar} from "react-step-progress-bar";
import Team from "../../models/Team";
import {Link, useLocation} from 'react-router-dom'
import {Img} from "react-image";
import LoadingSpinner from "../../components/LoadingSpinner";

const MetricDetailRow = ({metric, name}) => {

    return (
        <div className="flex flex-row justify-between m-0">
            <div className="inline-flex flex-row m-0">
                <p className="px-1"><strong>{metric.count}</strong></p>
                <p className="px-1"><strong>of</strong></p>
                <p className="px-1"><strong>{metric.max_count}</strong></p>
            </div>
            <p className="flex-grow p-0">{name}</p>
        </div>
    )
}

const TeamMatchDetails = props => {

    const location = useLocation()
    let metrics = props.team.metricScores();

    let detailsLink = () => {

        return {
            ...location,
            pathname: `team-profiles/${props.team.id}`,
        }
    }

    return (
        <div className="talent-match-details">
            <div className="talent-match-title">

                <div className="team-match-banner">
                    <Img
                        loader={(
                            <div className="self-stretch justify-center items-center flex flex-col">
                                <LoadingSpinner/>
                            </div>
                        )}
                        src={[props.team.image_path || TB.defaultUserProfileImagePath()]}
                        className="img-fluid  img-grayscale"/>
                    <h5>{TB.truncate(props.team.name, 40)}</h5>
                </div>
                <h4>
                    Match Summary
                </h4>
            </div>
            <div className="metric-container">

                {metrics.map((metric,i) => {

                    let tooltipId = `team-${props.team.id}-${i}`;

                    let {
                        nice_to_have,
                        important,
                        very_important,
                        overall
                    } = metric;

                    let disabled = TB.isDefined(overall?.max_count) && overall.max_count === 0;

                    return (
                        <div key={tooltipId} className={
                            TB.mapClass("metric-match", {disabled})
                        }>
                            <p>
                                {metric.label}
                                <small>
                                    {metric.type === 'experience' ? (
                                        <span>(<b>{metric.overall.max_count}&nbsp;</b> Experience Levels Selected)</span>
                                    ) : (
                                        <span>(<b>{metric.overall.max_count}&nbsp;</b> {TB.titleCase(TB.pluralize(metric.displayType || metric.type,metric.overall.max_count))} Selected)</span>
                                    )}
                                </small>
                            </p>


                            {metric.renderProgress()}

                            <div className="section-body">
                                <p className="section-heading">
                                    <strong>
                                        {metric.matchHeader}
                                    </strong>
                                </p>
                                {very_important && (
                                    <MetricDetailRow
                                        metric={very_important}
                                        name={`Very Important ${TB.titleCase(metric.type)}`}/>
                                )}

                                {important && (
                                    <MetricDetailRow
                                        metric={important}
                                        name={`Important ${TB.titleCase(metric.type)}`}/>
                                )}
                                {nice_to_have && (
                                    <MetricDetailRow
                                        metric={nice_to_have}
                                        name={`Nice to Have ${TB.titleCase(metric.type)}`}/>
                                )}

                                {metric.type === 'experience' && props.team && (props.team instanceof Team) && props.team.positions.length > 0
                                && TB.map(TB.take(props.team.sortedPositions(), 5), position => {
                                    // return (
                                    //     <div className="row m-0 self-stretch" key={`ser-${position.id}-vip`}>
                                    //         <p>{position.discipline.name}</p>
                                    //         <p className="ml-auto pl-1">
                                    //             <strong>{position.years_of_experience} Yrs</strong>
                                    //         </p>
                                    //     </div>
                                    // )
                                    // return (
                                    //     <div className="row m-0 self-stretch" key={`ser-${position.id}-vip`}>
                                    //         <p>{position.firstNamePlusInitial()}</p>
                                    //         <p className="ml-auto pl-1">
                                    //             <strong>{position.years_of_experience} Years</strong>
                                    //         </p>
                                    //     </div>
                                    // )
                                    return (
                                        <div className="flex flex-row justify-between m-0" key={`ser-${position.id}-vip`}>
                                            <p>{position.disciplines[0].name}</p>
                                            <p className="ml-auto pl-1 text-primary">
                                                <strong>{laravel.talent_scoring_options[position.disciplines[0].self_score]}</strong>
                                            </p>
                                        </div>
                                    )
                                    // TB.map(TB.take(props.team.services, 1), service => {
                                    //
                                    //     let vips = props.team.vipsForService(service);
                                    //     console.log(vips);
                                    //
                                    //     return (
                                    //         <div key={service.id} className="flex items-stretch self-stretch flex-col">
                                    //             <p className="mb-1"><strong>{service.name}</strong></p>
                                    //             {vips.map(vip => (
                                    //                 <div className="row m-0" key={`ser-${service.id}-vip-${vip.id}`}>
                                    //                     <p>{vip.discipline.name}</p>
                                    //                     <p className="ml-auto pl-1">
                                    //                         <strong>{laravel.talent_scoring_options[vip.discipline.self_score]}</strong>
                                    //                     </p>
                                    //                 </div>
                                    //             ))}
                                    //         </div>
                                    //     )

                                })}
                            </div>
                        </div>
                    );
                })}

            </div>

            <div className="match-footer flex flex-row mt-4 mx-0">
                <div className="md:w-5/12">
                    <div className="browse-talent-matching">

                        <p className="overall-progress">
                            <AnimatedNumber
                                value={props.team.matching.overall.percent}
                                formatValue={(value) => `${TB.round(value)}% Total Match`}
                                duration={1500}/>
                        </p>

                        <ProgressBar
                            filledBackground={TB.config('color.orange')}
                            height={20}
                            percent={props.team.matching.overall.percent}
                            unfilledBackground={TB.config('color.gray')}/>
                    </div>
                </div>
                <div className="md:w-3/12 ml-auto flex items-end">
                    <Link onClick={() => TB.event('Modal@hide', true)} to={detailsLink()}
                          className="btn btn-primary btn-block">See Match Details</Link>
                </div>
            </div>

        </div>
    );
};

TeamMatchDetails.propTypes = {
    criteria: PropTypes.object,
    team: PropTypes.object,
    projectId: PropTypes.any
};

export default TeamMatchDetails;